module.exports = __webpack_public_path__ + "static/img/vip.64f14d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip.png
// module id = 9MfT
// module chunks = 0